
import React from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Building, Plus, Trash2 } from "lucide-react";
import { Integration } from "@/api/IntegrationsAPI";

interface PmsSystemCardProps {
  onAddIntegration: () => void;
  onDeleteIntegration?: () => void;
  currentIntegration?: Integration | null;
}

const PmsSystemCard: React.FC<PmsSystemCardProps> = ({ 
  onAddIntegration,
  onDeleteIntegration,
  currentIntegration
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center">
          <Building className="mr-2 h-5 w-5" />
          Property Management System
        </CardTitle>
        <CardDescription>
          Connect to your property management system (PMS)
        </CardDescription>
      </CardHeader>
      <CardContent>
        {currentIntegration ? (
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="font-medium">{currentIntegration.name}</h3>
                <p className="text-sm text-muted-foreground">
                  Connected property management system
                </p>
              </div>
              <Button variant="destructive" onClick={onDeleteIntegration}>
                <Trash2 className="mr-2 h-4 w-4" />
                Delete Integration
              </Button>
            </div>
            <div className="grid grid-cols-1 gap-3 rounded-md bg-muted p-4">
              <div>
                <p className="text-sm font-medium">Integration ID</p>
                <p className="text-sm text-muted-foreground">{currentIntegration.id}</p>
              </div>
            </div>
          </div>
        ) : (
          <div className="flex items-center justify-between">
            <div>
              <h3 className="font-medium">PMS Integration</h3>
              <p className="text-sm text-muted-foreground">
                Connect to your property management system to sync reservations and operational data
              </p>
            </div>
            <Button onClick={onAddIntegration}>
              <Plus className="mr-2 h-4 w-4" />
              Add Integration
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default PmsSystemCard;
